import styled from "styled-components/macro";

export const AlarmBoxContainer = styled.div`
  width: 32.48px;

  height: 100%;
  display: flex;
`;

export const AlarmBoxLeft = styled.div`
  width: 50%;
  height: 100%;
  background: red;
  background: ${({ active }) => (!active ? "red" : "none")};
`;

export const AlarmBoxRight = styled.div`
  width: 50%;
  height: 100%;
  background: ${({ active }) => (active ? "red" : "none")};
`;

export const NoPiicLeft = styled.div`
  width: 50%;
  height: 100%;
  background: ${({ active }) => (active ? "#20fcf8" : "none")};
`;

export const NoPiicRight = styled.div`
  width: 50%;
  height: 100%;
  background: ${({ active }) => (!active ? "#20fcf8" : "none")};
`;
